import { Link } from 'react-router-dom';
import type { Contract, Page } from '../../lib/types';
import { useApiQuery } from '../../lib/useApi';
import { EmptyState, ErrorNote, PageHeader, Spinner, StatusBadge } from '../../ui/components';

/** Public contracts register — no sign-in required. */
export function ContractsRegister() {
  const contractsQ = useApiQuery<Page<Contract>>('/api/v1/m11/contracts?limit=50');

  return (
    <div>
      <PageHeader title="Contracts Register" subtitle="Signed procurement contracts, their milestones, variations, and performance record." />
      {contractsQ.error ? <ErrorNote message={contractsQ.error} /> : null}
      <div className="card overflow-x-auto">
        {contractsQ.loading ? (
          <Spinner />
        ) : (contractsQ.data?.items.length ?? 0) === 0 ? (
          <EmptyState title="No contracts yet" />
        ) : (
          <table className="w-full">
            <thead>
              <tr>
                <th className="table-head">Ref</th>
                <th className="table-head">Award</th>
                <th className="table-head text-right">Retention</th>
                <th className="table-head">Status</th>
                <th className="table-head">DocVault</th>
              </tr>
            </thead>
            <tbody>
              {contractsQ.data!.items.map((c) => (
                <tr key={c.id} className="hover:bg-slate-50">
                  <td className="table-cell font-mono text-xs">
                    <Link className="text-brand-600 hover:underline" to={`/procurement/contracts/${c.id}`}>{c.refNo}</Link>
                  </td>
                  <td className="table-cell font-mono text-xs text-slate-500">{c.awardId.slice(0, 16)}…</td>
                  <td className="table-cell text-right tabular-nums">{c.retentionPercent}%</td>
                  <td className="table-cell"><StatusBadge status={c.status} /></td>
                  <td className="table-cell text-xs text-slate-500">{c.docVault.serial ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
